import { isDesktop } from '@/runtime';

/**
 * PWA (T-171): service worker хранит оболочку приложения — без связи страница открывается,
 * а операции копятся в очереди (frontend/src/offline). Работает только по HTTPS или на localhost.
 * В десктопном клиенте не нужен: интерфейс и так внутри программы.
 */
export function registerServiceWorker(): void {
  if (isDesktop || !import.meta.env.PROD || !('serviceWorker' in navigator)) return;
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {
      // нет HTTPS или браузер запретил — приложение работает как обычный сайт
    });
  });
}
